import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeneralInfoTabsComponent } from './general-info-tabs.component';
import { ProfessionalLiabilityComponent } from './professional-liability/professional-liability.component';
import { GeneralLiabilityComponent } from './general-liability/general-liability.component';
import { BuildersLiabilityComponent } from './builders-liability/builders-liability.component';
import { PollutionLiabilityComponent } from './pollution-liability/pollution-liability.component';
import { ExcessLiabilityComponent } from './excess-liability/excess-liability.component';
import { AddressEditComponent } from './address-edit/address-edit.component';
import { ContractorsLiabilityComponent } from './contractors-liability/contractors-liability.component';

@NgModule({
  declarations: [
    GeneralInfoTabsComponent,
    ProfessionalLiabilityComponent,
    GeneralLiabilityComponent,
    BuildersLiabilityComponent,
    PollutionLiabilityComponent,
    ExcessLiabilityComponent,
    AddressEditComponent,
    ContractorsLiabilityComponent
  ],
  imports: [CommonModule],
  exports: [GeneralInfoTabsComponent]
})
export class GeneralInfoTabsModule {}
